import React from 'react';
import { useGlobalClientContext } from '../../common/GlobalClientContext';
import { convertNewLinesToBrs } from '@altus-ui/components_v2/utils/text';
import dataSyncImg from '../../../../public/images/datasync.png';

export default function DataSync() {
  const {
    i18nHelper: { t },
  } = useGlobalClientContext();

  const feature1Desc = t('public.site.product.data.sync.feature1.desc', {});

  return (
    <div className="flex w-full flex-col items-center gap-9xl mb-9xl">
      <div className="flex flex-col items-center gap-3xl w-[1280px]">
        <div className="flex flex-col items-center gap-2xl w-[1000px]">
          <div className="text-5xl leading-18xl text-primary font-semibold text-center w-full">
            {t('public.site.product.data.sync.feature1', {})}
          </div>
          <div className="text-xl font-regular leading-3xl text-secondary text-center w-full">
            {convertNewLinesToBrs(feature1Desc)}
          </div>
        </div>
      </div>
      <div className="bg-black rounded-md overflow-hidden flex items-center justify-center">
        <img
          src={dataSyncImg.src}
          alt="data sync"
          className="h-[568px] w-auto object-cover"
        />
      </div>
      <div className="flex flex-row items-start justify-center gap-9xl">
        <div className="flex flex-1 flex-col gap-s w-[480px]">
          <div className="text-xl font-bold leading-3xl text-gray-900">
            {t('public.site.product.data.sync.feature2', {})}
          </div>
          <div className="text-md font-regular leading-lg text-secondary">
            {t('public.site.product.data.sync.feature2.desc', {})}
          </div>
        </div>
        <div className="flex flex-1 flex-col gap-s w-[480px]">
          <div className="text-xl font-bold leading-3xl text-gray-900">
            {t('public.site.product.data.sync.feature3', {})}
          </div>
          <div className="text-md font-regular leading-lg text-secondary">
            {t('public.site.product.data.sync.feature3.desc', {})}
          </div>
        </div>
      </div>
    </div>
  );
}
